export enum ExternalLinks {
  S3_POLICY_EX = "https://docs.aws.amazon.com/AmazonS3/latest/userguide/example-policies-s3.html",
}
